<template>
  <div class="con">
    <div v-if="showList">
      <van-list v-model="listStatus.loading" :finished="listStatus.finished" offset="10" finished-text="没有更多了" :error.sync="listStatus.error" error-text="请求失败，点击重新加载" @load="getRecord">
        <div class="list">
          <div v-for="(item, index) in winnerList" :key="index" class="list-contain">
            <div class="listItem">
            <img v-if="item.userHeadPortraitUrl && item.nickName" style="width: 24px; height: 24px;" :src="item.userHeadPortraitUrl" />
            <img v-else v-show="item.nickName" style="width: 24px; height: 24px;" src="static/runtime/images/magic/award/userImg.png" />
          </div>
          <div class="listItem">
            {{ dealNickName(item.nickName) }}
          </div>
          <div class="listItem ellipsis">
            <div v-if="item.rewardType == '4'">{{ item.pointValue }}积分</div>
            <div v-else>{{ item.rewardName }}</div>
          </div>
          <div class="listItem">{{ item.creationDateStr }}</div>
          </div>
          </div>
      </van-list>
    </div>
    <div v-if="showNoData" class="no-data">
      <div style="margin-top: 200px">
        <img style="width: 100%" src="static/runtime/images/magic/award/no-data.png" alt=""/>
        <p class="no-data-text">暂无中奖数据</p>
      </div>
    </div>
  </div>
</template>
<script>
import { List } from "vant";
export default {
  components: {
    [List.name]: List, 
  },
  data() {
    return {
    showNoData:false,
    showList:true,
    winnerList: [],
    alipayUserId: "",
    openId: "",
    activityCode: "",
    channelCode: "",
    isUsed: "",
    listStatus:{loading: false,finished: false,error: false,},
    pages:{curPage:0,pageSize:30},
    };
  },
  created() {
    document.title = "中奖名单";
    this.activityCode = this.$route.query.activityCode;
    this.openId = this.$route.query.openId || "";
    this.channelCode = this.$route.query.channelCode;
    this.isUsed = this.$route.query.isUsed;
    this.alipayUserId = sessionStorage.getItem('alipayUserId') || "";
    
  },
  methods: {
    getRecord() {
      const self = this;
      self.listStatus.loading = true
      if (!self.channelCode && self.isUsed === "1") {
        self.channelCode = sessionStorage.getItem("navChannelCode");
      }
      self.$api.post({
        noLoading: true,
        sc: "mobileMarketing",
        url: "h5/bigWheel/reward/record/all/getFullListPaging",
        params:{
          curPage:self.pages.curPage + 1,
          pageSize:self.pages.pageSize,
          filter:{
            activityCode: self.activityCode,
            userOpenid: self.openId || "",
            channelCode: self.channelCode,
            alipayUserId: self.alipayUserId || "",
            loginType: sessionStorage.getItem('loginType') || "",
          },
          channelCode: self.channelCode,
        },
        success: (r) => {
          if(r && r.code === 200){
            self.listStatus = {loading : false,error : false,finished:false}
            if (r.result && r.result.length > 0) {
              self.pages.curPage += 1
              // 处理隐私信息
              self.$utils.addAnonymizedText(r.result,["nickName"]);
              self.winnerList = self.winnerList.concat(JSON.parse(JSON.stringify(r.result)));
              if(self.pages.curPage === r.result[0].pagingMap.totalPages){
                self.listStatus.finished = true
              }
            }
            if(self.winnerList.length > 0){
              self.showList = true
              self.showNoData = false
            }else{
              self.showList = false
              self.showNoData = true
            }
          }else{
            self.listStatus = {loading : false,error : true,finished:false}
          }
        },
      });
    },
    // 极少数错误情况下会出现nickname返回为null，做个兼容处理
    dealNickName(name){
      let dealName = ''
      if(name){
        dealName = name.substring(0,3)
      }
      return dealName
    }
  },
};
</script>
<style lang="scss" scoped>
.con {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  margin: 0px auto;
  border-top: 1px solid #efefef;
}
.list {
  padding: 0 4%;
  color: #333333;
  font-size: 13px;
  font-weight: 300;
}

.list .listItem:nth-child(1) {
  width: 10%;
  text-align: left;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

.list .listItem:nth-child(2) {
  width: 10%;
  text-align: left;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

.list .listItem:nth-child(3) {
  width: 50%;
  flex: 1;
  text-align: center;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

.list .listItem:nth-child(4) {
  min-width: 100px;
  text-align: right;
}

.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list li {
  display: flex;
  border-bottom: 0.5px solid #f0f0f0;
  padding: 10px 0;
}
.no-data {
  max-width: 480px;
  margin: 0px auto;
}
.no-data-text{
	width: 100%;
    text-align: center;
    color: #777777;
    font-size: 18px;
}
.list-contain{
  display: flex;
    height: 40px;
    border-bottom: solid 1px #f0f0f0;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/winnerList.vue